import { useLoaderData } from "react-router-dom";
import { HomepageLayoutLoaderData } from "@/routes/homePage/loaders/homePageLoader";
import LearningDashboard from "@/routes/homePage/homePage";
import AuthlessHomepage from "@/routes/homePage/authlessHomePage";

export default function HomepageLayout() {
  const data = useLoaderData() as HomepageLayoutLoaderData;

  if (data.isAuthenticated) {
    return <LearningDashboard />;
  }

  return <AuthlessHomepage />;
}
